export const ViewerType = 'wixui.SvgImage' as const;

export const SVG_TYPES = {
  SHAPE: 'shape',
  TINT: 'tint',
  COLOR: 'color',
  UGC: 'ugc',
};

// from santa-editor/packages/constants/base/baseConstants.ts `VECTOR_SHAPE_DEFAULT_PATH`
export const SVG_IMAGE_SHAPE_DEFAULT_PATH =
  'public/ab62ca24cd194952aad0707eead0c0f7/21555df8496d4c3c86bae2b4fcba13f1';
